export default __webpack_public_path__ + "static/media/icon-activity-opened.9f058fd8.svg";